import { IStorePack } from '@/interfaces/editor'
import { createAsyncThunk, createAction } from '@reduxjs/toolkit'
import api from '@services/api'
import { AxiosError } from 'axios'

export const setGraphicPacks = createAction<IStorePack[]>('graphicPacks/setGraphicPacks')

export const getGraphicPacks = createAsyncThunk<void, never, { rejectValue: Record<string, string[]> }>(
  'graphicPacks/getGraphicPacks',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const graphicPacks = await api.getGraphicPacks()

      dispatch(setGraphicPacks(graphicPacks))
    } catch (err) {
      return rejectWithValue(((err as AxiosError).response?.data as any)?.error.data || null)
    }
  }
)
